import { useState, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormValue, setValidValue } from "../driverSlice";

export const useFieldValidation = (fieldName, options = {}) => {
  const dispatch = useDispatch();
  const formValues = useSelector((state) => state.driver.formValues);
  const [touched, setTouched] = useState(false);
  const value = formValues[fieldName] ?? "";

  const {
    required = true,
    requiredMessage = `El campo es requerido`,
    validate = () => "",
    onKeyDown,
    transformValue = (v) => v,
  } = options;

  const getValidationError = useCallback(
    (val) => {
      if (required && (!val || val.trim() === "")) return requiredMessage;
      return validate(val);
    },
    [required, requiredMessage, validate]
  );

  const error = useMemo(() => getValidationError(value), [value, getValidationError]);

  const handleChange = useCallback(
    (e) => {
      const newValue = transformValue(e.target.value);
      dispatch(setFormValue({ field: fieldName, value: newValue }));

      const validationError = getValidationError(newValue);
      dispatch(setValidValue({ field: fieldName, isValid: validationError === "" }));
    },
    [dispatch, fieldName, getValidationError, transformValue]
  );

  const handleBlur = useCallback(() => setTouched(true), []);

  return {
    value,
    isInvalid: touched && error !== "",
    getErrorMessage: () => (touched ? error : ""),
    handlers: {
      onChange: handleChange,
      onBlur: handleBlur,
      onKeyDown,
    },
  };
};
